import { useMemo } from 'react';

import { useAclVersion } from '@/hooks/useSessionRefresh';
import { getUser } from '@/utilities/setting';
import { parseModuleOperations } from '@/utilities/voicePlanAcl';

export interface ModuleAcl {
  canView: boolean;
  canRead: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export function useModuleAcl(module: string): ModuleAcl {
  const aclVersion = useAclVersion();

  return useMemo(() => {
    const ops = parseModuleOperations(getUser()?.acl_settings?.module_operations) || {};
    const mod = ops?.[module] || {};
    return {
      canView: !!mod.view_permission,
      canRead: !!mod.read,
      canAdd: !!mod.add,
      canEdit: !!mod.edit,
      canDelete: !!mod.delete,
    };
  }, [module, aclVersion]);
}
